import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CRITICAL_INFO_TYPE } from '@app/modules/critical-info/consts/type';
import { SnackNotifier } from '@app/shared/notifier/snack-notifier';
import { Navigate } from '@ngxs/router-plugin';
import { Store, Actions, Select, ofActionDispatched } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import {
  INotification,
  INotificationForDoctor,
} from '../../interface/notification';
import { NotificationsActions } from '../../store/notifications.actions';
import { NotificationsState } from '../../store/notifications.state';
import {CriticalInfoActions} from '@app/modules/critical-info/store/critical-info.actions';

@Component({
  selector: 'app-doctor-blocker',
  templateUrl: './doctor-blocker.component.html',
  styleUrls: ['./doctor-blocker.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoctorBlockerComponent implements OnInit {
  @Select(NotificationsState.newCriticalNotifications)
  public criticalNotifications$: Observable<INotification[]>;
  @Select(NotificationsState.notificationCountByType)
  public notificationCountByType$: Observable<{
    livingWillUpdated: number;
    generalInfoUpdated: number;
    criticalInfoUpdated: number;
    patientQrCodeScanned: number;
  }>;

  public CRITICAL_INFO_TYPE = CRITICAL_INFO_TYPE;
  public checked = false;
  private _subscription = new Subscription();
  /**
   * @param store
   * @param actions
   * @param snack
   */
  constructor(
    private readonly store: Store,
    private readonly actions: Actions,
    private readonly snack: SnackNotifier
  ) {}

  ngOnInit(): void {
    this.subscribeOnAcknowledgedSuccess();
    this.subscribeOnAcknowledgedFailed();
  }

  confirm(criticalNotifications: INotificationForDoctor[]) {
    const notificationIds = criticalNotifications
      .map((x) => x.items.map((y) => y.id))
      .flat();
    this.store.dispatch(new NotificationsActions.MarkAsRead(notificationIds));

    this.store.dispatch(
      new CriticalInfoActions.UpdateCriticalInfo({  })
    );
  }

  subscribeOnAcknowledgedSuccess(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(NotificationsActions.MarkAsReadSuccess))
        .subscribe(() => {
          // Inline on the dashboard the dialog simply collapses (its *ngIf
          // empties); only the standalone route needs to navigate away.
          if (window.location.pathname.includes('doctor-blocker')) {
            this.store.dispatch([new Navigate(['/office/dashboard'])]);
          }
        })
    );
  }
  subscribeOnAcknowledgedFailed(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(NotificationsActions.MarkAsReadFailed))
        .subscribe(({ error }) => this.snack.error(error))
    );
  }
}
